"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcUniswapV2OracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcUniswapV2OracleFactory = /** @class */ (function (_super) {
    __extends(ArcUniswapV2OracleFactory, _super);
    function ArcUniswapV2OracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcUniswapV2OracleFactory.prototype.deploy = function (_kp3r, _uniV2Factory, overrides) {
        return _super.prototype.deploy.call(this, _kp3r, _uniV2Factory, overrides || {});
    };
    ArcUniswapV2OracleFactory.prototype.getDeployTransaction = function (_kp3r, _uniV2Factory, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _kp3r, _uniV2Factory, overrides || {});
    };
    ArcUniswapV2OracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcUniswapV2OracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcUniswapV2OracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcUniswapV2OracleFactory;
}(contracts_1.ContractFactory));
exports.ArcUniswapV2OracleFactory = ArcUniswapV2OracleFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_kp3r",
                type: "address",
            },
            {
                internalType: "address",
                name: "_uniV2Factory",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "kp3r",
                type: "address",
            },
        ],
        name: "Keep3rV1AddressSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pair",
                type: "address",
            },
        ],
        name: "PairAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pair",
                type: "address",
            },
        ],
        name: "PairRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pair",
                type: "address",
            },
        ],
        name: "PairUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newPeriodWindow",
                type: "uint256",
            },
        ],
        name: "PeriodWindowSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newUniV2Factory",
                type: "address",
            },
        ],
        name: "UniV2FactorySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "UpdatedAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "keeper",
                type: "address",
            },
        ],
        name: "WorkDone",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "KP3R",
        outputs: [
            {
                internalType: "contract IKeep3rV1",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_token0",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token1",
                type: "address",
            },
        ],
        name: "addPair",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_tokenIn",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_tokenOut",
                type: "address",
            },
        ],
        name: "current",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_pair",
                type: "address",
            },
        ],
        name: "getPairObservations",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price0Cumulative",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price1Cumulative",
                        type: "uint256",
                    },
                ],
                internalType: "struct ArcUniswapV2Oracle.Observation[]",
                name: "",
                type: "tuple[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getPairs",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_pair",
                type: "address",
            },
        ],
        name: "lastObservation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price0Cumulative",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price1Cumulative",
                        type: "uint256",
                    },
                ],
                internalType: "struct ArcUniswapV2Oracle.Observation",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_token0",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token1",
                type: "address",
            },
        ],
        name: "lastObservationTokens",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price0Cumulative",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price1Cumulative",
                        type: "uint256",
                    },
                ],
                internalType: "struct ArcUniswapV2Oracle.Observation",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_token0",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token1",
                type: "address",
            },
        ],
        name: "pairFor",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "pairObservations",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "price0Cumulative",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "price1Cumulative",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "periodWindow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_tokenIn",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_tokenOut",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_granularity",
                type: "uint256",
            },
        ],
        name: "quote",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tokenA",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenB",
                type: "address",
            },
        ],
        name: "removePair",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_kp3r",
                type: "address",
            },
        ],
        name: "setKeep3rAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_periodWindow",
                type: "uint256",
            },
        ],
        name: "setPeriodWindow",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_uniV2Factory",
                type: "address",
            },
        ],
        name: "setUniV2FactoryAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "uniV2Factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "updateAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_pair",
                type: "address",
            },
        ],
        name: "updatePair",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_token0",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token1",
                type: "address",
            },
        ],
        name: "updateTokensPair",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "work",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "workable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_pair",
                type: "address",
            },
        ],
        name: "workablePair",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_token0",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token1",
                type: "address",
            },
        ],
        name: "workableTokens",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
